/* BRIVAR footer — no mobile, transforma Institucional, Políticas e Novidades em abas.
   A Central de Atendimento (1ª coluna) e as Redes Sociais (5ª) ficam sempre abertas.
   Sem este script o rodapé continua aparecendo inteiro, com tudo aberto. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var toggles = [];

  function sync() {
    toggles.forEach(function (item) {
      if (mq.matches) {
        item.button.removeAttribute('tabindex');
        item.button.setAttribute('aria-expanded', item.section.classList.contains('is-open') ? 'true' : 'false');
      } else {
        item.button.setAttribute('tabindex', '-1');
        item.button.removeAttribute('aria-expanded');
      }
    });
  }

  function init() {
    var footer = document.querySelector('.footer-neo');
    if (!footer || footer.dataset.accordion) return;
    footer.dataset.accordion = 'true';
    toggles = [];

    var sections = Array.prototype.slice.call(footer.querySelectorAll('.footer-neo__top > section'), 1, 4);

    sections.forEach(function (section, index) {
      var title = section.querySelector('.footer-neo__title');
      if (!title) return;

      var panelId = 'footer-neo-panel-' + (index + 1);

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'footer-neo__toggle';
      button.setAttribute('aria-controls', panelId);

      var icon = document.createElement('span');
      icon.className = 'footer-neo__icon';
      icon.setAttribute('aria-hidden', 'true');

      /* Texto direto no botão (sem span) para herdar a tipografia do título. */
      button.appendChild(document.createTextNode(title.textContent.trim()));
      button.appendChild(icon);

      var panel = document.createElement('div');
      panel.className = 'footer-neo__panel';
      panel.id = panelId;

      var inner = document.createElement('div');
      inner.className = 'footer-neo__panel-inner';
      while (title.nextSibling) inner.appendChild(title.nextSibling);
      panel.appendChild(inner);

      title.textContent = '';
      title.appendChild(button);
      section.appendChild(panel);
      section.classList.add('footer-neo__acc');

      button.addEventListener('click', function () {
        if (!mq.matches) return;
        var open = section.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      toggles.push({ section: section, button: button });
    });

    sync();
  }

  if (mq.addEventListener) mq.addEventListener('change', sync);
  else mq.addListener(sync);

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
